// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"feb426ff","453":"2aa622ad","635":"43257a0f"}[chunkId] + ".chunk.js";
};